import { getBaseURL, getClient } from '../BLL/clients/HttpClient';
import { ApiEndPoint } from '../BLL/Enums/ApiEndPoint';

interface AIMessage {
  id: string;
  role: 'user' | 'assistant' | 'function';
  content: string;
  createdAt: string;
}

export interface AISession {
  id: string;
  userId: string;
  title?: string;
  createdAt: string;
  updatedAt: string;
  messages?: AIMessage[];
}

export interface AISessionsResponse {
  sessions: AISession[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

export const getAISessions = async (page = 1, pageSize = 20) => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });

  const { data } = await client.get<AISessionsResponse>('ai/sessions', {
    params: { page, pageSize },
  });

  return data;
};

export const getAISession = async (sessionId: string) => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });

  const { data } = await client.get<AISession>(`ai/sessions/${sessionId}`);

  return data;
};
